/* tslint:disable */
/* eslint-disable */
/**
 * OSB Workspaces manager API
 * Opensource Brain Platform - Reference Workspaces manager API
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResourceOrigin,
    ResourceOriginFromJSON,
    ResourceOriginFromJSONTyped,
    ResourceOriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {Array<ResourceOrigin>}
     * @memberof InlineObject
     */
    resourceorigins?: Array<ResourceOrigin>;
}

export function InlineObjectFromJSON(json: any): InlineObject {
    return InlineObjectFromJSONTyped(json, false);
}

export function InlineObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resourceorigins': !exists(json, 'resourceorigins') ? undefined : ((json['resourceorigins'] as Array<any>).map(ResourceOriginFromJSON)),
    };
}

export function InlineObjectToJSON(value?: InlineObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resourceorigins': value.resourceorigins === undefined ? undefined : ((value.resourceorigins as Array<any>).map(ResourceOriginToJSON)),
    };
}


